import { ReportTypeName } from '~/pages/reports/entry/useReportType'
import { ReportType } from '~/pages/reports/shared/types'
import { createTelemetryAPI } from '~/utils/telemetry'

export const clusterDetailTelemetry = createTelemetryAPI(({ track }) => ({
  clickBack() {
    return track('Cluster Detail: Click Back')
  },
  clickDetailItem(name: string) {
    return track('Cluster Detail: Click Detail Item', { name })
  },
  clickMetricsCard() {
    return this.clickDetailItem('Metrics')
  },
  clickLogsCard() {
    return this.clickDetailItem('Instance Logs')
  },
  clickSlowQueryCard() {
    return this.clickDetailItem('Slow Query')
  },
  resolveSQLStatementRoute(
    source: 'resolver' | 'direct-v2',
    decision: 'denied' | 'v1' | 'v2',
    reason: string
  ) {
    return track('Cluster Detail: Resolve SQL Statement Route', {
      source,
      decision,
      reason
    })
  },
  clickBenchmarkReportCard() {
    return this.clickDetailItem(ReportTypeName[ReportType.Benchmark])
  },
  clickComparisonReportCard() {
    return this.clickDetailItem(ReportTypeName[ReportType.Comparison])
  },
  clickMetricsItem(url: string) {
    return track('Cluster Detail: Click Metrics Item', { url })
  },
  clickInstanceLogsItem(id: string) {
    return track('Cluster Detail: Click Instance Logs Item', { id })
  },
  clickSlowQueriesItem(url: string) {
    return track('Cluster Detail: Click Slow Queries Item', { url })
  },
  clickDownloadItem(id: string, type: 'full' | 'without_logs_metrics') {
    return track('Cluster Detail: Click Download Data Item', { id, type })
  },
  requestDiagModel(
    type: string,
    {
      cluster_id,
      model_name,
      time_range
    }: {
      cluster_id: string
      model_name: string
      time_range: [number, number]
    }
  ) {
    return track('Cluster Detail: Request Diagnostic Model', {
      type,
      cluster_id,
      model_name,
      time_range
    })
  },
  clickDiagModelLink(type: string, url: string) {
    return track('Cluster Detail: Click Diagnostic Model Link', { type, url })
  },
  clickMetricOverviewItem(payload: { metric_overview_item: string }) {
    return track('Cluster Detail: Click Metric Overview Item', payload)
  },
  clickNextDay() {
    return track('Cluster Detail: Click Next Day')
  },
  clickPreviousDay() {
    return track('Cluster Detail: Click Previous Day')
  },
  selectTimeRange(time_range: { start: number; end: number }) {
    return track('Cluster Detail: Select Time Range', { time_range })
  },
  clickNav(name: string) {
    return track('Cluster Detail: Click Nav', { name })
  }
}))
